module.exports = __webpack_public_path__ + "img/contact-stars.f40ec4ee.webp";